// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"1a0558c4","433":"6d07d504","738":"4b01b163","787":"2d6e36eb"}[chunkId] + ".chunk.js";
};